import RenterProfile from "./RenterProfile";

export default RenterProfile;
